<!-- eslint-disable no-nested-ternary -->
<template>
  <section class="locations">
    <div class="card-actions card">
      <div class="card-content">
        <div class="content flex md:flex-row flex-col space-y-4 md:space-y-0">
          <h1 class="title">
            {{
              activateMode
                ? "Please add a location before proceed"
                : "Location Configuration"
            }}
          </h1>
          <button
            class="button primary"
            @click="showAddEditLocationModal()"
          >
            Add a location
          </button>
        </div>
      </div>
    </div>
    <br>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <br>
        <div
          v-if="locations.length"
          class="grid_locations"
        >
          <div
            v-for="(location, idx_location) in locations"
            :key="'location_' + idx_location"
            class="row"
          >
            <div class="card">
              <header class="card-header">
                <div class="card-header-title is-primary-border">
                  <span class="location-name">
                    {{ location.name }}
                  </span>
                  <span class="location-address">
                    {{ getCompanyAddress(location) }}
                  </span>
                </div>
                <div class="card-header-icon">
                  <div
                    class="dropdown"
                    :class="{ 'is-active': location.show_menu }"
                  >
                    <div class="dropdown-trigger">
                      <button
                        class="button is-white"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        @click="location.show_menu = !location.show_menu"
                      >
                        <span class="icon is-small">
                          <i
                            class="fas fa-ellipsis-v"
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </div>
                    <div
                      id="dropdown-menu"
                      class="dropdown-menu"
                      role="menu"
                    >
                      <div class="dropdown-content">
                        <button
                          class="dropdown-item"
                          @click="showEditLocationModal(location)"
                        >
                          Edit
                        </button>
                        <button
                          class="dropdown-item"
                          @click="showDeleteLocationModal(location)"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="no-data card">
            <header class="card-header">
              <p>No Locations</p>
            </header>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal add-edit-location"
      :class="{ 'is-active': show_add_edit_location_modal }"
    >
      <div
        class="modal-background"
        @click="hideAddEditLocationModal()"
      />
      <div class="modal-content">
        <div class="box">
          <p class="title">
            {{ locationEditMode ? "Edit" : "Add" }} location
          </p>
          <p
            v-if="!locationEditMode"
            class="sub-title"
          >
            Create new location name and address
          </p>

          <div class="location-info">
            <div class="location-address">
              <div class="address">
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Location name</span>
                      <span
                        :data-tooltip="
                          'Required field' +
                            '\n' +
                            'Allowed character count is 50'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.locationName"
                      class="input is-mandatory"
                      :class="errors.locationName.visible ? 'has-error' : ''"
                      type="text"
                      placeholder="Location name"
                    >
                    <span v-if="errors.locationName.visible">{{
                      errors.locationName.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Location code</span>
                      <span
                        :data-tooltip="
                          'Required field' +
                            '\n' +
                            'Allowed character count is 50'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.ein"
                      class="input ein-input is-mandatory"
                      :class="errors.ein.visible ? 'has-error' : ''"
                      placeholder="Location code"
                      type="text"
                    >
                    <span v-if="errors.ein.visible">{{
                      errors.ein.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Email</span>
                      <span
                        :data-tooltip="
                          'Required field' +
                            '\n' +
                            'Allowed character count is 100' +
                            '\n' +
                            'Should be valid'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.email"
                      class="input email-input is-mandatory"
                      :class="errors.email.visible ? 'has-error' : ''"
                      placeholder="Email address"
                      type="text"
                    >
                    <span v-if="errors.email.visible">{{
                      errors.email.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Phone number</span>
                      <span
                        :data-tooltip="
                          'Required field' + '\n' + 'Only digits are allowed'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.phoneNumber"
                      v-restrict:[restrictValue]="models.phoneNumber"
                      class="input phone-input is-mandatory"
                      :class="errors.phone.visible ? 'has-error' : ''"
                      placeholder="Phone number"
                      type="text"
                    >
                    <span v-if="errors.phone.visible">{{
                      errors.phone.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Address 1</span>
                      <span
                        :data-tooltip="'Allowed character count is 50'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.address1"
                      class="input address-input is-mandatory"
                      :class="errors.address1.visible ? 'has-error' : ''"
                      placeholder="Address line 1"
                      type="text"
                    >
                    <span v-if="errors.address1.visible">{{
                      errors.address1.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Address 2</span>
                      <span
                        :data-tooltip="'Allowed character count is 50'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.address2"
                      class="input address-input is-mandatory"
                      :class="errors.address2.visible ? 'has-error' : ''"
                      placeholder="Address line 2"
                      type="text"
                    >
                    <span v-if="errors.address2.visible">{{
                      errors.address2.message
                    }}</span>
                  </div>
                </div>
                <div class="city-zipcode">
                  <div class="field">
                    <div class="control">
                      <label class="label">
                        <span>City</span>
                        <span
                          :data-tooltip="'Allowed character count is 50'"
                          class="tooltip has-tooltip-right has-tooltip-arrow"
                        >
                          <img
                            src="../../../public/assets/img/info.svg"
                            alt=""
                          >
                        </span>
                      </label>
                      <input
                        v-model="models.city"
                        class="input is-mandatory"
                        :class="errors.city.visible ? 'has-error' : ''"
                        placeholder="City"
                        type="text"
                      >
                      <span v-if="errors.city.visible">{{
                        errors.city.message
                      }}</span>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <label class="label">
                        <span>Zip code</span>
                        <span
                          :data-tooltip="'Allowed character count is 50'"
                          class="tooltip has-tooltip-right has-tooltip-arrow"
                        >
                          <img
                            src="../../../public/assets/img/info.svg"
                            alt=""
                          >
                        </span>
                      </label>
                      <input
                        v-model="models.zipCode"
                        class="input zipcode-input is-mandatory"
                        :class="errors.zipcode.visible ? 'has-error' : ''"
                        placeholder="Zip code"
                        type="text"
                      >
                      <span v-if="errors.zipcode.visible">{{
                        errors.zipcode.message
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div class="control select">
                    <label class="label">
                      <span>State</span>
                      <span
                        :data-tooltip="'Required field'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <div
                      class="select-container"
                      :class="locationEditMode ? 'disabled' : ''"
                    >
                      <select
                        v-model="models.selectedState"
                        :disabled="locationEditMode"
                        class="al-select is-mandatory"
                        :class="errors.locationState.visible ? 'has-error' : ''"
                      >
                        <option
                          selected
                          disabled
                          hidden
                          value=""
                        >
                          Choose a state ...
                        </option>
                        <template v-for="state in states">
                          <option
                            :key="state.uuid"
                            :value="state.uuid"
                          >
                            {{ getStateName(state) }}
                          </option>
                        </template>
                      </select>
                    </div>
                    <span
                      v-if="errors.locationState.visible"
                      class="error-info"
                    >{{ errors.locationState.message }}</span>
                  </div>
                </div>
                <!-- <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Newspaper name</span>
                      <span
                        :data-tooltip="'Required field'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.newspaper_name"
                      class="input is-mandatory"
                      :class="errors.newspaper_name.visible ? 'has-error' : ''"
                      placeholder="Newspaper name"
                      type="text"
                    >
                    <span v-if="errors.newspaper_name.visible">{{
                      errors.newspaper_name.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Newspaper email</span>
                      <span
                        :data-tooltip="
                          'Required field' + '\n' + 'Should be valid'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.newspaper_email"
                      class="input is-mandatory"
                      :class="errors.newspaper_email.visible ? 'has-error' : ''"
                      placeholder="Newspaper email"
                      type="text"
                    >
                    <span v-if="errors.newspaper_email.visible">{{
                      errors.newspaper_email.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Newspaper publication</span>
                      <span
                        :data-tooltip="'Required field'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.newspaper_publication"
                      class="input is-mandatory"
                      :class="
                        errors.newspaper_publication.visible ? 'has-error' : ''
                      "
                      placeholder="Newspaper publication"
                      type="text"
                    >
                    <span v-if="errors.newspaper_publication.visible">{{
                      errors.newspaper_publication.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Newspaper contact</span>
                      <span
                        :data-tooltip="'Required field'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.newspaper_contact"
                      class="input is-mandatory"
                      :class="
                        errors.newspaper_contact.visible ? 'has-error' : ''
                      "
                      placeholder="Newspaper contact"
                      type="text"
                    >
                    <span v-if="errors.newspaper_contact.visible">{{
                      errors.newspaper_contact.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Days for publication 1</span>
                      <span
                        :data-tooltip="
                          'Required field' + '\n' + 'Only digits are allowed'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.days_publication_one"
                      class="input is-mandatory"
                      :class="
                        errors.days_publication_one.visible ? 'has-error' : ''
                      "
                      placeholder="Days for publication 1"
                      type="text"
                    >
                    <span v-if="errors.days_publication_one.visible">{{
                      errors.days_publication_one.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Days for publication 2</span>
                      <span
                        :data-tooltip="
                          'Required field' + '\n' + 'Only digits are allowed'
                        "
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.days_publication_two"
                      class="input is-mandatory"
                      :class="
                        errors.days_publication_two.visible ? 'has-error' : ''
                      "
                      placeholder="Days for publication 2"
                      type="text"
                    >
                    <span v-if="errors.days_publication_two.visible">{{
                      errors.days_publication_two.message
                    }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Ad email subject</span>
                      <span
                        :data-tooltip="'Required field'"
                        class="tooltip has-tooltip-right has-tooltip-arrow"
                      >
                        <img
                          src="../../../public/assets/img/info.svg"
                          alt=""
                        >
                      </span>
                    </label>
                    <input
                      v-model="models.ad_email_subject"
                      class="input is-mandatory"
                      :class="
                        errors.ad_email_subject.visible ? 'has-error' : ''
                      "
                      placeholder="Ad email subject"
                      type="text"
                    >
                    <span v-if="errors.ad_email_subject.visible">{{
                      errors.ad_email_subject.message
                    }}</span>
                  </div>
                </div> -->
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Corp Code</span>
                    </label>
                    <input
                      v-model="models.corpCode"
                      class="input"
                      :class="errors.corpCode.visible ? 'has-error' : ''"
                      placeholder="Corp Code"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Corp User Name</span>
                    </label>
                    <input
                      v-model="models.corpUserName"
                      class="input"
                      :class="errors.corpUserName.visible ? 'has-error' : ''"
                      placeholder="Corp User Name"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Api Key</span>
                    </label>
                    <input
                      v-model="models.apiKey"
                      class="input"
                      :class="errors.apiKey.visible ? 'has-error' : ''"
                      placeholder="Api Key"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Corp Password</span>
                    </label>
                    <input
                      v-model="models.corpPassword"
                      class="input"
                      :class="errors.corpPassword.visible ? 'has-error' : ''"
                      placeholder="Corp Password"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Storedgefms Api Key</span>
                    </label>
                    <input
                      v-model="models.fms_api_key"
                      class="input"
                      :class="errors.fms_api_key.visible ? 'has-error' : ''"
                      placeholder="Storedgefms Api Key"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Storedgefms Api Secret</span>
                    </label>
                    <input
                      v-model="models.fms_api_secret"
                      class="input"
                      :class="errors.fms_api_secret.visible ? 'has-error' : ''"
                      placeholder="Storedgefms Api Secret"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>District</span>
                    </label>
                    <input
                      v-model="models.district"
                      class="input"
                      placeholder="District"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>District Manager(s)</span>
                    </label>
                    <textarea
                      v-model="models.districtManager"
                      class="input"
                      placeholder="District Manager(s)"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Region</span>
                    </label>
                    <input
                      v-model="models.region"
                      class="input"
                      placeholder="Region"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Regional Manager(s)</span>
                    </label>
                    <textarea
                      v-model="models.regionManager"
                      class="input"
                      placeholder="Regional Manager(s)"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Payment link</span>
                    </label>
                    <input
                      v-model="models.paymentLink"
                      class="input"
                      placeholder="Payment link"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Activation date</span>
                    </label>
                    <input
                      v-model="models.activationDate"
                      class="input"
                      placeholder="Activation date"
                      type="date"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Deactivation date</span>
                    </label>
                    <input
                      v-model="models.deactivationDate"
                      class="input"
                      placeholder="Deactivation date"
                      type="date"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Number of units</span>
                    </label>
                    <input
                      v-model="models.numberOfUnits"
                      class="input"
                      placeholder="Number of units"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Total rentable square footage</span>
                    </label>
                    <input
                      v-model="models.totalRentableFootage"
                      class="input"
                      placeholder="Total rentable square footage"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Occupancy</span>
                    </label>
                    <input
                      v-model="models.occupancy"
                      class="input"
                      placeholder="Occupancy"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>SaaS service fee per month</span>
                    </label>
                    <input
                      v-model="models.saasServiceFeePerMonth"
                      class="input"
                      placeholder="SaaS service fee per month"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Letter budget</span>
                    </label>
                    <input
                      v-model="models.letterBudget"
                      class="input"
                      placeholder="Letter budget"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Ad budget</span>
                    </label>
                    <input
                      v-model="models.adBudget"
                      class="input"
                      placeholder="Ad budget"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Primary Publisher</span>
                    </label>
                    <input
                      v-model="models.primaryPublisher"
                      class="input"
                      placeholder="Primary Publisher"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Alt Publisher</span>
                    </label>
                    <input
                      v-model="models.altPublisher"
                      class="input"
                      placeholder="Alt Publisher"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Auction site</span>
                    </label>
                    <input
                      v-model="models.auctionSite"
                      class="input"
                      placeholder="Auction site"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Annual letter cost target</span>
                    </label>
                    <input
                      v-model="models.annualLetterCostTarget"
                      class="input"
                      placeholder="Annual letter cost target"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Annual ad cost target</span>
                    </label>
                    <input
                      v-model="models.annualAdCostTarget"
                      class="input"
                      placeholder="Annual ad cost target"
                      type="number"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control select">
                    <label class="label">
                      <span>TMS</span>
                    </label>
                    <select
                      v-model="models.tms"
                      class="al-select is-mandatory"
                    >
                      <option
                        selected
                        value=""
                      >
                        Select option
                      </option>
                      <option
                        value="site_link"
                      >
                        SiteLink
                      </option>
                      <option
                        value="store_edge"
                      >
                        StorEdge
                      </option>
                      <option
                        value="ssm"
                      >
                        SSM
                      </option>
                      <option
                        value="hummingbird"
                      >
                        Hummingbird
                      </option>
                    </select>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>TMS Notes</span>
                    </label>
                    <textarea
                      v-model="models.tMSNotes"
                      class="input"
                      placeholder="TMS Notes"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Towing company</span>
                    </label>
                    <textarea
                      v-model="models.towingCompany"
                      class="input"
                      placeholder="Towing company"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Lien lawyer</span>
                    </label>
                    <textarea
                      v-model="models.lienLawyer"
                      class="input"
                      placeholder="Lien lawyer"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Auction cycle duration</span>
                    </label>
                    <input
                      v-model="models.auctionCycleDuration"
                      class="input"
                      placeholder="Auction cycle duration"
                      type="text"
                    >
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">
                      <span>Notes</span>
                    </label>
                    <textarea
                      v-model="models.notes"
                      class="input"
                      placeholder="Notes"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-actions control">
            <button
              type="button"
              class="button is-outlined"
              @click="hideAddEditLocationModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="button primary"
              @click="addEditLocation()"
            >
              {{ locationEditMode ? "Save" : "Create" }}
            </button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideAddEditLocationModal()"
      />
    </div>
    <div
      class="modal"
      :class="{ 'is-active': show_delete_location_modal }"
    >
      <div
        class="modal-background"
        @click="hideDeleteLocationModal()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>Remove this location?</h6>

          <p
            class="control has-text-right"
            style="margin-top: 2rem"
          >
            <button
              class="button is-white"
              @click="hideDeleteLocationModal()"
            >
              Cancel
            </button>
            <button
              class="button is-danger is-outlined"
              @click="removeLocation()"
            >
              Confirm
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideDeleteLocationModal()"
      />
    </div>
    <div
      class="modal add-state"
      :class="{ 'is-active': show_add_state_modal }"
    >
      <div
        class="modal-background"
        @click="hideAddStateModal()"
      />
      <div class="modal-content">
        <div class="box">
          <h5>No states are tied to the company</h5>

          <p
            class="modal-actions control"
            style="margin-top: 2rem"
          >
            <button
              class="button is-outlined"
              @click="hideAddStateModal()"
            >
              Cancel
            </button>
            <button
              v-if="role === roles.SUPER_ADMIN"
              class="button primary"
              @click="handleAddState()"
            >
              Add
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideAddStateModal()"
      />
    </div>
  </section>
</template>
<script>
// @todo remove this
/* eslint-disable camelcase */

import UserService from '../../services/user.service';
import DashboardService from '../../services/dashboard.service';
import WorkflowService from '../../services/workflow.service';
import { Roles } from '../../constants';
import { isValidEmail } from '../../utils/validationUtils';

const userService = new UserService();
const dashboardService = new DashboardService();
const workflowService = new WorkflowService();

const defaultErrors = {
  locationName: {
    visible: false,
    message: ''
  },
  ein: {
    visible: false,
    message: ''
  },
  email: {
    visible: false,
    message: ''
  },
  phone: {
    visible: false,
    message: ''
  },
  address1: {
    visible: false,
    message: ''
  },
  address2: {
    visible: false,
    message: ''
  },
  city: {
    visible: false,
    message: ''
  },
  zipcode: {
    visible: false,
    message: ''
  },
  locationState: {
    visible: false,
    message: ''
  },
  corpCode: {
    visible: false,
    message: ''
  },
  corpUserName: {
    visible: false,
    message: ''
  },
  apiKey: {
    visible: false,
    message: ''
  },
  fms_api_secret: {
    visible: false,
    message: ''
  },
  fms_api_key: {
    visible: false,
    message: ''
  },
  corpPassword: {
    visible: false,
    message: ''
  },
  newspaper_name: {
    visible: false,
    message: ''
  },
  newspaper_email: {
    visible: false,
    message: ''
  },
  newspaper_publication: {
    visible: false,
    message: ''
  },
  newspaper_contact: {
    visible: false,
    message: ''
  },
  days_publication_one: {
    visible: false,
    message: ''
  },
  days_publication_two: {
    visible: false,
    message: ''
  },
  ad_email_subject: {
    visible: false,
    message: ''
  }
};
const defaultModels = {
  locationName: '',
  ein: '',
  email: '',
  phoneNumber: '',
  address1: '',
  address2: '',
  city: '',
  zipCode: '',
  corpUserName: '',
  corpCode: '',
  corpPassword: '',
  apiKey: '',
  fms_api_key: '',
  fms_api_secret: '',
  selectedState: '',
  // newspaper_name: '',
  // newspaper_email: '',
  // newspaper_publication: '',
  // newspaper_contact: '',
  // days_publication_one: '',
  // days_publication_two: '',
  // ad_email_subject: '',
  district: '',
  districtManager: '',
  region: '',
  regionManager: '',
  paymentLink: '',
  activationDate: '',
  deactivationDate: '',
  numberOfUnits: '',
  totalRentableFootage: '',
  occupancy: '',
  saasServiceFeePerMonth: '',
  letterBudget: '',
  adBudget: '',
  auctionSite: '',
  primaryPublisher: '',
  altPublisher: '',
  annualLetterCostTarget: '',
  annualAdCostTarget: '',
  tms: '',
  tMSNotes: '',
  towingCompany: '',
  lienLawyer: '',
  notes: '',
  auctionCycleDuration: ''
};

export default {
  name: 'LocationsComponent',
  props: {
    activateMode: Boolean
  },
  data() {
    return {
      selectedOrganizationUuid: null,
      selectedOrganizationId: null,
      states: [],
      locations: [],
      show_add_edit_location_modal: false,
      show_add_state_modal: false,
      useMainOfficeLocation: false,
      show_delete_location_modal: false,
      selectedLocationUuid: '',
      role: this.$store.state.user.role,
      roles: Roles,
      locationEditMode: false,
      locationToEdit: null,
      errors: { ...defaultErrors },
      restrictValue: '[0-9]',
      models: { ...defaultModels }
    };
  },
  computed: {
    locationsList() {
      return this.$store.state.locationsList;
    }
  },
  watch: {
    locationsList(newLocations) {
      this.locations = newLocations.map((location) => ({
        ...location,
        show_menu: false
      }));
    }
  },
  mounted() {
    const { state } = this.$store;
    const selectedOrganization = { ...state.selectedOrganization };
    const organization = { ...state.organization };
    // eslint-disable-next-line no-nested-ternary
    const currentOrganization = !this.activateMode
      && selectedOrganization
      && Object.keys(selectedOrganization).length
      ? selectedOrganization
      : organization && Object.keys(organization).length
        ? organization
        : {};
    this.selectedOrganizationId = currentOrganization && Object.keys(currentOrganization).length
      ? currentOrganization.id_organization
      : '';
    this.selectedOrganizationUuid = currentOrganization && Object.keys(currentOrganization).length
      ? currentOrganization.uuid
      : '';
    this.getStates();
    if (this.$root.showLocationAdd) {
      this.showAddEditLocationModal();
      this.$root.showLocationAdd = false;
    } else {
      this.getLocations();
    }
    this.$store.commit('setAccountReady', true);
  },
  methods: {
    hideAddStateModal() {
      this.show_add_state_modal = false;
    },
    handleAddState() {
      this.$root.$emit('showAddState');
    },
    showAddEditLocationModal() {
      if (!this.states || !this.states.length) {
        this.show_add_state_modal = true;
        return;
      }
      this.show_add_state_modal = false;
      this.show_add_edit_location_modal = true;

      if (this.locationEditMode) {
        const {
          name: locationName,
          ein,
          email,
          phone_number: phoneNumber,
          address1,
          address2,
          city,
          zipcode: zipCode,
          corp_code,
          corp_user_name,
          corp_password,
          api_key,
          fms_api_key,
          fms_api_secret,
          // newspaper_name,
          // newspaper_email,
          // newspaper_publication,
          // newspaper_contact,
          // days_publication_one,
          // days_publication_two,
          // ad_email_subject,
          state: { uuid: selectedState },
          district,
          district_manager,
          region,
          regional_manager,
          payment_link,
          activation_date,
          deactivation_date,
          number_of_units,
          total_rentable_square_footage,
          occupancy,
          saas_service_fee,
          letter_budget,
          ad_budget,
          primary_publisher,
          alt_publisher,
          auction_site,
          annual_letter_cost_target,
          annual_ad_cost_target,
          tms,
          tms_notes,
          towing_company,
          lien_lawyer,
          auction_cycle_duration,
          notes
        } = this.locationToEdit;

        this.models = {
          ...this.models,
          locationName: locationName || '',
          ein: ein || '',
          email: email || '',
          phoneNumber: phoneNumber || '',
          address1: address1 || '',
          address2: address2 || '',
          city: city || '',
          zipCode: zipCode || '',
          selectedState: selectedState || '',
          corpCode: corp_code || '',
          corpUserName: corp_user_name || '',
          corpPassword: corp_password || '',
          apiKey: api_key || '',
          fms_api_key: fms_api_key || '',
          fms_api_secret: fms_api_secret || '',
          // newspaper_name: newspaper_name || '',
          // newspaper_email: newspaper_email || '',
          // newspaper_publication: newspaper_publication || '',
          // newspaper_contact: newspaper_contact || '',
          // days_publication_one: days_publication_one || '',
          // days_publication_two: days_publication_two || '',
          // ad_email_subject: ad_email_subject || '',
          district: district || '',
          districtManager: district_manager || '',
          region: region || '',
          regionManager: regional_manager || '',
          paymentLink: payment_link || '',
          activationDate: activation_date || '',
          deactivationDate: deactivation_date || '',
          numberOfUnits: number_of_units || '',
          totalRentableFootage: total_rentable_square_footage || '',
          occupancy: occupancy || '',
          saasServiceFeePerMonth: saas_service_fee || '',
          letterBudget: letter_budget || '',
          adBudget: ad_budget || '',
          primaryPublisher: primary_publisher || '',
          altPublisher: alt_publisher || '',
          annualLetterCostTarget: annual_letter_cost_target || '',
          annualAdCostTarget: annual_ad_cost_target || '',
          auctionSite: auction_site || '',
          tms: tms || '',
          tMSNotes: tms_notes || '',
          towingCompany: towing_company || '',
          lienLawyer: lien_lawyer || '',
          notes: notes || '',
          auctionCycleDuration: auction_cycle_duration || ''
        };
      }
    },
    showAdmin() {
      const { role } = this;
      return role === Roles.ADMIN || role === Roles.CS_ADMIN;
    },
    hideAddEditLocationModal() {
      this.show_add_edit_location_modal = false;
      this.show_add_state_modal = false;
      this.resetLocationInfo();
    },
    resetLocationInfo() {
      this.models = { ...defaultModels };
      this.errors = { ...defaultErrors };
      this.locationToEdit = null;
      this.locationEditMode = false;
    },
    removeLocation() {
      const self = this;
      this.hideDeleteLocationModal();
      userService
        .removeLocation(this.selectedLocationUuid)
        .then((response) => {
          const { result } = response.data;
          self.getLocations();
          self.$root.$emit('showToast', {
            message:
              result.message
              || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    addEditLocation() {
      const self = this;
      const {
        locationName,
        ein,
        email,
        phoneNumber,
        address1,
        address2,
        city,
        zipCode,
        selectedState,
        corpCode,
        corpUserName,
        corpPassword,
        apiKey,
        fms_api_secret,
        fms_api_key,
        // newspaper_name,
        // newspaper_email,
        // newspaper_publication,
        // newspaper_contact,
        // days_publication_one,
        // days_publication_two,
        // ad_email_subject,
        district,
        districtManager,
        region,
        regionManager,
        paymentLink,
        activationDate,
        deactivationDate,
        numberOfUnits,
        totalRentableFootage,
        occupancy,
        saasServiceFeePerMonth,
        letterBudget,
        adBudget,
        auctionSite,
        primaryPublisher,
        altPublisher,
        annualLetterCostTarget,
        annualAdCostTarget,
        tms,
        tMSNotes,
        towingCompany,
        lienLawyer,
        notes,
        auctionCycleDuration
      } = this.models;
      const { locationEditMode } = this;
      const isValid = this.validateLocation();

      if (!isValid) {
        return;
      }
      const data = new FormData();

      data.append('name', locationName);
      data.append('address1', address1);
      data.append('address2', address2);
      data.append('city', city);
      data.append('zipcode', zipCode);
      data.append('uuid_state', selectedState);
      data.append('ein', ein);
      data.append('email', email.toLowerCase());
      data.append('phone_number', phoneNumber);
      data.append('corp_code', corpCode);
      data.append('corp_user_name', corpUserName);
      data.append('corp_password', corpPassword);
      data.append('api_key', apiKey);
      data.append('fms_api_secret', fms_api_secret);
      data.append('fms_api_key', fms_api_key);
      // data.append('newspaper_name', newspaper_name);
      // data.append('newspaper_email', newspaper_email);
      // data.append('newspaper_publication', newspaper_publication);
      // data.append('newspaper_contact', newspaper_contact);
      // data.append('days_publication_one', days_publication_one);
      // data.append('days_publication_two', days_publication_two);
      // data.append('ad_email_subject', ad_email_subject);
      data.append('district', district);
      data.append('district_manager', districtManager);
      data.append('region', region);
      data.append('regional_manager', regionManager);
      data.append('payment_link', paymentLink);
      data.append('activation_date', activationDate);
      data.append('deactivation_date', deactivationDate);
      data.append('number_of_units', numberOfUnits);
      data.append('total_rentable_square_footage', totalRentableFootage);
      data.append('occupancy', occupancy);
      data.append('saas_service_fee', saasServiceFeePerMonth);
      data.append('letter_budget', letterBudget);
      data.append('ad_budget', adBudget);
      data.append('primary_publisher', primaryPublisher);
      data.append('alt_publisher', altPublisher);
      data.append('auction_site', auctionSite);
      data.append('annual_letter_cost_target', annualLetterCostTarget);
      data.append('annual_ad_cost_target', annualAdCostTarget);
      data.append('tms', tms ?? null);
      data.append('tms_notes', tMSNotes);
      data.append('towing_company', towingCompany);
      data.append('lien_lawyer', lienLawyer);
      data.append('auction_cycle_duration', auctionCycleDuration);
      data.append('notes', notes);

      let locationAction = () => userService.createCompany(data);

      if (locationEditMode) {
        locationAction = () => userService.editCompany(data, this.locationToEdit.uuid);
      }

      if (this.role === Roles.SUPER_ADMIN) {
        data.append('id_organization', this.selectedOrganizationId);
      }
      locationAction()
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', {
              message:
                message
                || `Company successfully ${
                  locationEditMode ? 'updated' : 'created'
                }`,
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.hideAddEditLocationModal();
            self.getLocations();
          } else {
            const locationCodeDuplication = message?.toLowerCase() === 'location with this ein exist';
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
            if (locationCodeDuplication) {
              self.errors = {
                ...self.errors,
                ein: {
                  message,
                  visible: true
                }
              };
            }
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    setEmployeeData(company_uuid) {
      const self = this;

      // getting employee data (user, company, rights) and storing it
      dashboardService
        .getEmployeeCompany(company_uuid)
        .then((response) => {
          const { data } = response;

          if (data.status === 'success') {
            self.$store.commit('setEmployeeData', response.data);

            workflowService
              .getWorkflowList(company_uuid)
              .then((resp) => {
                const { status, result } = resp.data;
                self.$store.commit(
                  'setAccountReady',
                  status === 'success' && result.list.length
                );
              })
              .catch(() => {
                self.$store.commit('setAccountReady', false);
              });
          } else {
            self.$root.$emit('showToast', {
              message:
                'Impossible to find your employee info. Please try later or complete your profile',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    getLocations() {
      const self = this;
      const prevLocations = this.locations || [];
      const organization = this.$store.state.organization || {};

      userService
        .getLocations(
          this.$store.state.user.role,
          this.selectedOrganizationUuid
        )
        .then((resp) => {
          const locationsData = resp.data;
          const { status: locationStatus, result } = locationsData;

          if (locationStatus === 'success') {
            self.locations = result.map((location) => ({
              ...location,
              show_menu: false
            }));
            if (
              result?.length
              && !prevLocations.length
              && Object.keys(organization).length
              && self.selectedOrganizationUuid === organization.uuid
            ) {
              self.$store.commit('setLocationsList', locationsData);
              self.setEmployeeData(result[0].uuid);
            }
          } else {
            self.$root.$emit('showToast', {
              message:
                'Impossible to find your location info. Please try later or complete your profile',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to find your location info. Please try later or complete your profile',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    validateLocation() {
      const {
        locationName,
        ein,
        email,
        phoneNumber,
        address1,
        address2,
        city,
        zipCode,
        selectedState
        // newspaper_name,
        // newspaper_email,
        // newspaper_publication,
        // newspaper_contact,
        // days_publication_one,
        // days_publication_two,
        // ad_email_subject
      } = this.models;

      const locationNameError = {
        visible: false,
        message: ''
      };
      const einError = {
        visible: false,
        message: ''
      };
      const emailError = {
        visible: false,
        message: ''
      };
      const phoneError = {
        visible: false,
        message: ''
      };
      const address1Error = {
        visible: false,
        message: ''
      };
      const address2Error = {
        visible: false,
        message: ''
      };
      const cityError = {
        visible: false,
        message: ''
      };
      const zipcodeError = {
        visible: false,
        message: ''
      };
      const locationStateError = {
        visible: false,
        message: ''
      };
      // const newspaperNameError = {
      //   visible: false,
      //   message: ''
      // };
      // const newspaperEmailError = {
      //   visible: false,
      //   message: ''
      // };
      // const newspaperPublicationError = {
      //   visible: false,
      //   message: ''
      // };
      // const newspaperContactError = {
      //   visible: false,
      //   message: ''
      // };
      // const daysPublicationOneError = {
      //   visible: false,
      //   message: ''
      // };
      // const daysPublicationTwoError = {
      //   visible: false,
      //   message: ''
      // };
      // const adEmailSubjectError = {
      //   visible: false,
      //   message: ''
      // };

      let message = '';

      if (!this.stateEditMode) {
        if (!selectedState) {
          message += 'State is required <br >';
          locationStateError.visible = true;
          locationStateError.message = 'State is required';
        }
      }

      // if (!newspaper_name) {
      //   message += 'Newspaper name is required <br>';
      //   newspaperNameError.visible = true;
      //   newspaperNameError.message = 'Newspaper name is required';
      // }

      // if (!newspaper_email) {
      //   message += 'Newspaper email is required <br>';
      //   newspaperEmailError.visible = true;
      //   newspaperEmailError.message = 'Newspaper email is required';
      // } else if (!isValidEmail(newspaper_email)) {
      //   message += 'Please provide a valid newspaper email<br >';
      //   newspaperEmailError.visible = true;
      //   newspaperEmailError.message = 'Newspaper email is invalid';
      // }

      // if (!newspaper_publication) {
      //   message += 'Newspaper publication is required <br>';
      //   newspaperPublicationError.visible = true;
      //   newspaperPublicationError.message = 'Newspaper publication is required';
      // }

      // if (!newspaper_contact) {
      //   message += 'Newspaper contact is required <br>';
      //   newspaperContactError.visible = true;
      //   newspaperContactError.message = 'Newspaper contact is required';
      // }

      // if (!days_publication_one) {
      //   message += 'Newspaper contact is required <br>';
      //   daysPublicationOneError.visible = true;
      //   daysPublicationOneError.message = 'Days for publication 1 is required';
      // }

      // if (!days_publication_two) {
      //   message += 'Newspaper contact is required <br>';
      //   daysPublicationTwoError.visible = true;
      //   daysPublicationTwoError.message = 'Days for publication 2 is required';
      // }

      // if (!ad_email_subject) {
      //   message += 'Newspaper contact is required <br>';
      //   adEmailSubjectError.visible = true;
      //   adEmailSubjectError.message = 'Ad email subject is required';
      // }

      if (!locationName) {
        message += 'Location name is required <br>';
        locationNameError.visible = true;
        locationNameError.message = 'Location name is required';
      } else if (locationName.length > 50) {
        message += 'Allowed character count is 50 for Location name<br >';
        locationNameError.visible = true;
        locationNameError.message = 'Allowed character count is 50';
      }

      if (!ein) {
        message += 'Location code is required<br >';
        einError.visible = true;
        einError.message = 'Location code is required';
      } else if (ein.length > 50) {
        message += 'Allowed character count is 50 for Location code<br >';
        einError.visible = true;
        einError.message = 'Allowed character count is 50';
      }

      if (!email) {
        message += 'Email address is required<br >';
        emailError.visible = true;
        emailError.message = 'Email address is required';
      } else if (email.length > 100) {
        message += 'Allowed character count is 100 for Email address<br >';
        emailError.visible = true;
        emailError.message = 'Allowed character count is 100';
      } else if (!isValidEmail(email)) {
        message += 'Please provide a valid email<br >';
        emailError.visible = true;
        emailError.message = 'Email is invalid';
      }

      if (!phoneNumber) {
        message += 'Phone number is required<br >';
        phoneError.visible = true;
        phoneError.message = 'Phone number is required';
      } else if (phoneNumber.length > 50) {
        message += 'Allowed character count is 50 for Phone number<br >';
        phoneError.visible = true;
        phoneError.message = 'Allowed character count is 50';
      }

      if (address1.length > 50) {
        message += 'Allowed character count is 50 for Address 1<br >';
        address1Error.visible = true;
        address1Error.message = 'Allowed character count is 50';
      }

      if (address2.length > 50) {
        message += 'Allowed character count is 50 for Address 2<br >';
        address2Error.visible = true;
        address2Error.message = 'Allowed character count is 50';
      }

      if (city.length > 50) {
        message += 'Allowed character count is 50 for City<br >';
        cityError.visible = true;
        cityError.message = 'Allowed character count is 50';
      }

      if (zipCode.length > 50) {
        message += 'Allowed character count is 50 for Zipcode<br >';
        zipcodeError.visible = true;
        zipcodeError.message = 'Allowed character count is 50';
      }

      this.errors = {
        ...this.errors,
        locationName: locationNameError,
        ein: einError,
        address1: address1Error,
        address2: address2Error,
        city: cityError,
        zipcode: zipcodeError,
        locationState: locationStateError,
        email: emailError,
        phone: phoneError
        // newspaper_name: newspaperNameError,
        // newspaper_email: newspaperEmailError,
        // newspaper_publication: newspaperPublicationError,
        // days_publication_one: daysPublicationOneError,
        // days_publication_two: daysPublicationTwoError,
        // ad_email_subject: adEmailSubjectError,
        // newspaper_contact: newspaperContactError
      };
      const isValid = !message.length;

      if (!isValid) {
        this.$root.$emit('showToast', {
          message,
          options: { cssClass: 'is-danger', duration: 10000 }
        });
      }
      return isValid;
    },
    getCompanyAddress(location) {
      const {
        city,
        state: { abbreviation }
      } = location;
      return [city, abbreviation].filter((it) => it).join(', ');
    },
    getStateName(state = {}) {
      return [state.name, state.abbreviation].filter((it) => it).join(', ');
    },
    showDeleteLocationModal(location) {
      this.show_delete_location_modal = true;
      this.selectedLocationUuid = location.uuid;
    },
    hideDeleteLocationModal() {
      this.show_delete_location_modal = false;
    },
    showEditLocationModal(location) {
      this.locationEditMode = true;
      this.locationToEdit = location;
      this.showAddEditLocationModal();
    },
    getStates() {
      const self = this;

      userService
        .getStates(this.selectedOrganizationUuid)
        .then((response) => {
          const { status, result } = response.data;

          if (status === 'success') {
            self.states = [...result];
          } else {
            self.$root.$emit('showToast', {
              message:
                'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    }
  }
};
</script>
<style
  scoped
  src="../../../public/assets/css/bulma-extension/bulma-tooltip.min.css"
></style>
<style scoped lang="scss">
.select:not(.is-multiple):not(.is-loading) .select-container ~ .error-info {
  font-size: 0.8rem !important;
}
.is-mandatory ~ span:not(.icon),
.input.is-mandatory ~ span:not(.icon) {
  font-size: 0.8rem !important;
}
.locations {
  .is-borderless {
    border: 0;
  }

  .grid_locations {
    .row {
      margin-top: 10px;

      .card {
        height: 100%;
        display: flex;
        flex-direction: column;

        .card-header {
          margin: 0;

          .card-header-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            border-left-width: 4px;
            border-left-style: solid;
            padding: 0 1rem;
            font-weight: 400;

            .location-name {
              font-size: 18px;
              font-weight: bold;
            }

            .location-address {
              font-size: 14px;
              color: #81868d;
            }
          }

          .card-header-icon {
            max-width: 72px;
          }
        }

        .card-content {
          border-top: 1px solid #ededed;
        }
      }
    }
  }

  .card-actions {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;

    .content {
      display: flex;
      justify-content: space-between;

      .title {
        margin: 0;
      }
    }
  }

  .card {
    &.no-data {
      display: flex;
      justify-content: center;
      padding: 15px 0;
    }
  }

  .add-edit-location {
    .modal-content {
      max-width: 700px;

      .box {
        .title {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
        }

        .sub-title {
          font-size: 16px;
          margin: 5px 0 10px;
        }

        .minimum-number-label {
          margin-bottom: 0.75rem;
          display: block;
        }

        .location-info {
          margin-top: 25px;

          .location-address {
            margin-top: 40px;

            .location-header {
              display: flex;
              justify-content: space-between;

              h6 {
                margin: 0;
              }

              .checkbox {
                display: flex;
                align-items: center;

                span {
                  cursor: pointer;
                  margin-left: 5px;
                  font-size: 14px;
                }
              }
            }

            .address {
              display: flex;
              flex-direction: column;

              .ein-input,
              .email-input,
              .phone-input,
              .address-input {
                margin-top: 15px;
              }

              .city-zipcode {
                display: flex;
                justify-content: space-between;

                .field {
                  width: 48%;

                  .input {
                    width: 100%;
                  }
                }
              }

              .state {
                margin-top: 15px;

                .select {
                  width: 48%;

                  select {
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .add-edit-location,
  .add-state {
    .modal-content {
      .box {
        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 25px;

          .button {
            width: 120px;
          }
        }
      }
    }
  }
}
</style>
